/*  ob- product recommendation slider */
document.addEventListener('DOMContentLoaded', () => {

  let ready = false;
  let currentIndex = 0;
  
  const setup = () => {
    if (ready) {
      return;
    }

    const wrapper = document.querySelector('.ob-simple-slider-wrapper');
    if (!wrapper) {
      return;
    }

    const items = document.querySelector('.ob-simple-slider-items');

    items.addEventListener('scroll', (event) => {
      const wrapperRect = wrapper.getBoundingClientRect();
      const totalWidth = wrapperRect.width;
      const itemRect = items.children[0].getBoundingClientRect();
      const itemWidth = itemRect.width;
      const scrollX = event.target.scrollLeft + (totalWidth - itemWidth);
      const result = parseInt(scrollX / itemWidth);
      currentIndex = result;
      updateDots();
    });

    ready = true;
    const dotsContainer = document.querySelector('.ob-simple-slider-dots');
    const children = items.children;
    const updateScroll = () => {
      const element = children[currentIndex];
      const rect = element.getBoundingClientRect();
      const x = rect.width * currentIndex;
      items.scrollTo(x, 0);
    }

    const updateDots = () => {
      const dots = dotsContainer.children;
      Array.from(dots).forEach((dot, index) => {
        if (currentIndex === index) {
          dot.classList.add('selected');
        } else {
          if (dot.classList.contains('selected')) {
            dot.classList.remove('selected');
          }
        }
      })
    }

    Array.from(children).forEach((element, index) => {
      const dot = document.createElement('div');
      dot.classList.add('ob-simple-slider-nav-dot');
      dot.onclick = () => {
        currentIndex = index;
        updateScroll();
        updateDots();
      }

      dotsContainer.appendChild(dot);
    });

    const buttonPrev = document.querySelector('.ob-simple-slider-button-prev');
    buttonPrev.onclick = () => {
      if (currentIndex <= 0) {
        currentIndex = children.length - 1;
      } else {
        currentIndex --;
      }
      updateScroll();
      updateDots();
    }

    const buttonNext = document.querySelector('.ob-simple-slider-button-next');

    buttonNext.onclick = () => {
      if (currentIndex >= children.length - 1) {
        currentIndex = 0;
      } else {
        currentIndex ++;
      }
      updateScroll();
      updateDots();
    }

    updateDots();
  }
  window.addEventListener('product-recommendations:load', () => {
    setup();
  });
});
